export default "__VITE_PUBLIC_ASSET__268e3601__"